module.exports = __webpack_public_path__ + "img/BARCODE.2c559aeb.svg";